import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export function Services() {
    const { t } = useTranslation();

    const servicesObject = [
        {
            key: 1,
            imgSrc: "https://img.icons8.com/?size=100&id=12447&format=png&color=ffffff",
            heading: 'services.softwareDevelopment',
            des: "services.softwareDescription",
        },
        {
            key: 2,
            imgSrc: "https://img.icons8.com/?size=100&id=24870&format=png&color=ffffff",
            heading: 'services.architectureAndDesign',
            des: "services.architectureDescription",
        },
        {
            key: 7,
            imgSrc: "https://img.icons8.com/?size=100&id=4pA6aw4OTuwp&format=png&color=ffffff",
            heading: 'services.aiAndMachineLearning',
            des: "services.aiDescription",
        },
        {
            key: 4,
            imgSrc: "https://img.icons8.com/?size=100&id=2zyvaojJtgOA&format=png&color=ffffff",
            heading: 'services.devOpsAndCloud',
            des: "services.devOpsDescription",
        },
        {
            key: 5,
            imgSrc: "https://img.icons8.com/?size=100&id=11678&format=png&color=ffffff",
            heading: 'services.securityServices',
            des: "services.securityDescription",
        },
        {
            key: 6,
            imgSrc: "https://img.icons8.com/?size=100&id=ZQ9axxszRfad&format=png&color=ffffff",
            heading: 'services.dataScienceAndAnalytics',
            des: "services.dataScienceDescription",
        },
        {
            key: 8,
            imgSrc: "https://img.icons8.com/?size=100&id=52230&format=png&color=ffffff",
            heading: 'services.productStrategy',
            des: "services.productStrategyDescription",
        },
        {
            key: 3,
            imgSrc: "https://img.icons8.com/?size=100&id=22136&format=png&color=ffffff",
            heading: 'services.qualityAssurance',
            des: "services.qualityDescription",
        },
    ];

    return (
        <>
            {/* Main Heading for Services */}
            <Helmet>
                <meta name="description" content={t("meta.description")} />
                <meta name="keywords" content={t("meta.keywords")} />
                <meta name="author" content={t("meta.author")} />
            </Helmet>
            <Helmet>
                <title>Professional Development Services UK | MVP, AI & Cloud Solutions - Wasif Shehzad</title>
                <meta name="description" content="Team Lead & Solution Architect offering MVP development, AI integration, cloud services & software architecture for UK/USA startups. 30+ projects delivered." />
                <meta name="keywords" content="MVP Development UK, AI Integration Services, Cloud Solutions, Software Architecture, Team Lead Services, Solution Architect, React Development, Python Development, Node.js Services, AWS Consulting" />
                <meta name="author" content="Wasif Shehzad" />

                {/* Open Graph Tags */}
                <meta property="og:title" content="Professional Development Services | MVP & AI Solutions" />
                <meta property="og:description" content="Team Lead & Solution Architect offering comprehensive development services including MVP development, AI integration, cloud architecture, and software solutions for UK and USA clients." />
                <meta property="og:url" content="https://wasif-shehzad.github.io/me/services" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://wasif-shehzad.github.io/me/assets/wasif-BCCeH9qb.webp" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Development Services | MVP & AI Solutions" />
                <meta name="twitter:description" content="Comprehensive development services including MVP development, AI integration, cloud solutions, and software architecture for startups and enterprises." />
                <meta name="twitter:image" content="https://wasif-shehzad.github.io/me/assets/wasif-BCCeH9qb.webp" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://wasif-shehzad.github.io/me/services" />
            </Helmet>
            <p className="text-3xl text-center font-bold py-20 md:text-4xl lg:text-5xl">
                {t('services.heading')}
            </p>
            <div className="grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-16 text-white px-6 lg:px-24 pointer">
                {servicesObject?.map((service) => (
                    <div key={service.key} className="service-card border-2 px-2 border-[#5ecaf4] hover:border-2 rounded-xl h-auto py-8 transition-all duration-300">
                        <div className="h-28 flex justify-center items-center">
                            <img src={service.imgSrc} alt={t(service.heading)} className="w-24 h-24" />
                        </div>
                        <h1 className="text-center font-bold text-xl mt-4">{t(service.heading)}</h1>
                        <p className="text-center p-4 mx-4 text-sm">{t(service.des)}</p>
                    </div>
                ))}
            </div>


            <div style={{
                position: 'absolute',
                left: '-9999px',
                top: '-9999px',
                height: '0',
                overflow: 'hidden'
            }}>
                <h1>Professional Development Services - Team Lead & Solution Architect</h1>
                <h2>Comprehensive Software Solutions for UK and USA Businesses</h2>

                <h3>MVP Development Services</h3>
                <p>
                    Professional <strong>MVP development services</strong> for startups and enterprises.
                    Build <strong>minimum viable products in 4-8 weeks</strong> using modern technologies including
                    <strong>React.js, Python, Node.js, and Next.js</strong>.
                    <strong>30+ successful MVP deliveries</strong> for <strong>UK and USA clients</strong>.
                    Services available in <strong>London, Manchester, New York, San Francisco</strong> and remote worldwide.
                </p>

                <h3>AI Integration & Machine Learning</h3>
                <p>
                    Expert <strong>AI integration services</strong> including <strong>GPT development, LLM integration,
                        and machine learning solutions</strong>. Custom <strong>AI development for web applications,
                            chatbots, and automation systems</strong>.
                    <strong>AI consulting</strong> for businesses looking to implement artificial intelligence technologies.
                    Available for projects in <strong>United Kingdom and United States</strong>.
                </p>

                <h3>Cloud Solutions & DevOps</h3>
                <p>
                    Professional <strong>cloud architecture services</strong> with <strong>AWS, Azure, and Google Cloud</strong>.
                    <strong>DevOps implementation</strong> for continuous integration and deployment.
                    <strong>Serverless architecture</strong> design and implementation.
                    <strong>Cloud migration services</strong> for existing applications.
                    Serving clients in <strong>UK and USA markets</strong>.
                </p>

                <h3>Solution Architecture & Technical Leadership</h3>
                <p>
                    Experienced <strong>Solution Architect</strong> providing <strong>system design and technical architecture</strong> services.
                    <strong>Team Lead</strong> services for <strong>technical leadership and project management</strong>.
                    <strong>Software architecture</strong> for scalable and maintainable systems.
                    Available for <strong>technical consulting and leadership roles</strong> in <strong>London, Manchester, Birmingham,
                        New York, San Francisco, Chicago</strong>.
                </p>

                <h3>Full-Stack Development Services</h3>
                <p>
                    Comprehensive <strong>full-stack development</strong> using <strong>React.js, Python, Node.js, TypeScript, and modern frameworks</strong>.
                    <strong>Web application development</strong> for businesses and startups.
                    <strong>Mobile app development</strong> with responsive design.
                    <strong>API development and integration</strong> services.
                    Development services for clients across <strong>United Kingdom and United States</strong>.
                </p>

                <h3>Service Locations & Coverage</h3>
                <p>
                    <strong>MVP Developer London</strong>, <strong>AI Integration Manchester</strong>, <strong>Cloud Architect Birmingham</strong>,
                    <strong>Solution Architect Leeds</strong>, <strong>Team Lead Glasgow</strong>, <strong>React Developer Bristol</strong>,
                    <strong>Python Developer Edinburgh</strong>, <strong>Node.js Developer Liverpool</strong>, <strong>DevOps Consultant Sheffield</strong>,
                    <strong>Software Development Newcastle</strong>, <strong>Full-Stack Developer New York</strong>, <strong>AI Specialist San Francisco</strong>,
                    <strong>Cloud Solutions Los Angeles</strong>, <strong>MVP Development Chicago</strong>, <strong>Solution Architect Austin</strong>,
                    <strong>Technical Lead Seattle</strong>, <strong>Python Development Boston</strong>, <strong>Node.js Services Miami</strong>,
                    <strong>DevOps Engineer Denver</strong>, <strong>Web Development Dallas</strong>, <strong>Team Lead Washington DC</strong>,
                    <strong>AI Integration San Diego</strong>.
                </p>

                <h3>Industry Solutions</h3>
                <p>
                    <strong>SaaS development</strong>, <strong>startup technology solutions</strong>, <strong>enterprise software development</strong>,
                    <strong>e-commerce solutions</strong>, <strong>fintech applications</strong>, <strong>healthcare technology</strong>,
                    <strong>education technology</strong>, <strong>real estate technology</strong>, <strong>logistics software</strong>,
                    <strong>manufacturing solutions</strong>, <strong>retail technology</strong>, <strong>automation systems</strong>.
                </p>

                <h3>Technology Stack Expertise</h3>
                <p>
                    <strong>React.js development</strong>, <strong>Python programming</strong>, <strong>Node.js backend</strong>,
                    <strong>TypeScript applications</strong>, <strong>Next.js framework</strong>, <strong>AWS cloud services</strong>,
                    <strong>MongoDB databases</strong>, <strong>PostgreSQL systems</strong>, <strong>Docker containers</strong>,
                    <strong>Kubernetes orchestration</strong>, <strong>React Native mobile</strong>, <strong>GraphQL APIs</strong>,
                    <strong>RESTful API development</strong>, <strong>machine learning models</strong>, <strong>AI integration</strong>.
                </p>

                <h3>Why Choose Our Services</h3>
                <p>
                    <strong>30+ successful project deliveries</strong>, <strong>4-8 week MVP development timeline</strong>,
                    <strong>UK and USA client experience</strong>, <strong>technical leadership expertise</strong>,
                    <strong>solution architecture background</strong>, <strong>modern technology stack</strong>,
                    <strong>scalable system design</strong>, <strong>quality assurance processes</strong>,
                    <strong>competitive pricing</strong>, <strong>reliable delivery timelines</strong>.
                </p>

                <h3>Get Started with Professional Development Services</h3>
                <p>
                    Looking to <strong>hire MVP developer UK</strong> or <strong>AI integration specialist USA</strong>?
                    Need <strong>Team Lead services London</strong> or <strong>Solution Architect Manchester</strong>?
                    Professional <strong>development services</strong> for <strong>React projects, Python applications,
                        Node.js systems, AI integration, and cloud solutions</strong>.
                    Contact for <strong>custom software development, MVP creation, AI implementation, and technical leadership</strong>
                    services in <strong>United Kingdom and United States</strong>.
                </p>
            </div>
            <style>
                {`
                .service-card {
                    transition: all 0.6s ease-in-out;
                }
                .service-card:hover {
                    transform: scale(1.05); 
                }
                `}
            </style>
        </>
    );
}
